import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  // 422 validation shape from hierarchy_validation.py: { errors: [str, ...] }
  if (detail && Array.isArray(detail.errors)) {
    const errs = detail.errors.filter((s) => typeof s === "string");
    if (errs.length === 0) return "Validation failed.";
    if (errs.length === 1) return errs[0];
    return `${errs.length} validation errors: ${errs[0]}${errs.length > 1 ? ` (+${errs.length - 1} more)` : ""}`;
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/**
 * Extract the node / peer-connection ids referenced in a 422 hierarchy
 * validation payload so the UI can highlight the offending elements.
 * Handles the shape { errors: ["node '<id>' ...", "peer_connection '<id>' ..."] }.
 */
export function extractErrorNodeIds(detail) {
  if (!detail || !Array.isArray(detail.errors)) return [];
  const ids = new Set();
  const re = /(?:node|parent|peer_connection|parentId)\s+'([^']+)'/g;
  for (const line of detail.errors) {
    if (typeof line !== "string") continue;
    let m;
    while ((m = re.exec(line)) !== null) {
      if (m[1]) ids.add(m[1]);
    }
  }
  return Array.from(ids);
}
